import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { INFORMATION_FIELD_REQUEST } from "../../../../../../enums/ApiPaths";
import Wrapper from "../../../../../../components/wrappers/Wrapper";
import MyLoadingButton from "../../../../../../components/buttons/MyLoadingButton";
import UserHint from "../../../../../../components/display/UserHint";
import { ADD_CUSTOM_INFORMATION_FIELD } from "../../../../../../enums/PermissionTitles";
import { informationFieldCategories } from "../enums/InformationFieldCategories.jsx";
import useSubmit from "../../../../../master/species/hooks/useSubmit.jsx";
import { ABOUT_US, INFO_FIELD } from "../../../../../../enums/QueryKeys.jsx";
export const informationFieldMaxLengthTitle = 50;
export const informationFieldMaxLengthValue = 70;
export default function InformationFieldForm() {
  const { t, i18n } = useTranslation();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useFormContext();
  const { id: clinicId } = useParams();

  const submittion = useSubmit(
    null,
    INFORMATION_FIELD_REQUEST + clinicId,
    INFO_FIELD,
    [ABOUT_US]
  );
  const currentLanguage = i18n.language;

  const submitData = async (data) => {
    var obj = {
      ...data,
      labelTranslation: {
        [currentLanguage]: data?.label,
      },
    };

    if (data?.fieldValue) {
      obj = {
        ...obj,
        fieldValueTranslation: {
          [currentLanguage]: data?.fieldValue,
        },
      };
    }
    submittion.submitCallback(obj);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(submitData)}>
      <Stack mb={2} mt={2}>
        <Wrapper direction="column" alignItems="flex-start" spacing={2}>
          <Controller
            name="label"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label={t("InformationFieldTitlePlaceholder")}
                fullWidth
                inputProps={{ maxLength: informationFieldMaxLengthTitle }}
                error={!!errors.label}
                helperText={errors.label ? errors.label.message : ""}
              />
            )}
          />
          <Controller
            name="fieldValue"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label={t("InformationFieldValuePlaceholder")}
                fullWidth
                inputProps={{ maxLength: informationFieldMaxLengthValue }}
                error={!!errors.fieldValue}
                helperText={errors.fieldValue ? errors.fieldValue.message : ""}
              />
            )}
          />
          <Controller
            name="category"
            defaultValue={""}
            control={control}
            render={({ field }) => (
              <FormControl fullWidth error={!!errors?.category}>
                <InputLabel>{t("Category")}</InputLabel>
                <Select {...field} label={t("Category")}>
                  {informationFieldCategories.map((category) => (
                    <MenuItem value={category?.id} key={category?.id}>
                      {t(category?.value)}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {errors?.category?.message || ""}
                </FormHelperText>
              </FormControl>
            )}
          />
          <Box
            sx={{
              ml: 2,
            }}
          >
            <MyLoadingButton
              message={t("Add")}
              isLoading={submittion.loading}
              permissions={[ADD_CUSTOM_INFORMATION_FIELD]}
            />
          </Box>
        </Wrapper>
        <UserHint hint={"AddServiceUserHint"} />
      </Stack>
    </form>
  );
}
